module.exports = __webpack_public_path__ + "static/media/cards_banner.a90281b5.png";